// extracted by mini-css-extract-plugin
var _1 = "DocFlowEpostValidationErrorsReportButton-moduleDocFlowEpostValidationErrorsReportButton__R8M5g DocFlowEpostValidationPreviewButton-moduleDocFlowEpostValidationPreviewButton__Psjor ButtonIcon-moduleicon__Hawdx IconNG-moduleiconContainer__SxWZ0";
export { _1 as "DocFlowEpostValidationErrorsReportButton" }
